export enum CountryName {
  "Egypt" = "Egypt",
  "Morocco" = "Morocco",
  "Lebanon" = "Lebanon",
  "Saudi Arabia" = "Saudi Arabia",
  "United Arab Emirates" = "United Arab Emirates",
  "United States" = "United States",
  "Kuwait" = "Kuwait",
}
